import { FlexGrid } from "@grapecity/wijmo.react.grid";
import { Row, Column } from "@grapecity/wijmo.grid";
import { useQubBringValue } from "context/bringValueContext";

const BringValueInGrid = () => {
  const { openBringValue } = useQubBringValue();

  const bringValueHandler = async (args) => {
    const { flex, e } = args;

    /* In case column is bring value */
    if (flex.activeEditor && e.col === 0) {
      //Gets the HTMLInputElement that represents the currently active cell editor.If no cell is currently being edited, this property returns null.//
      e.cancel = true;
      // const value = flex.activeEditor.value;

      if (e.col === 0)
        openBringValue({
          datakey: "APIPelPromExpl",
          title: "Συναλασσόμενοι",
          callback: (value) => {
            if (e.row === 0 && e.col === 0) {
              flex.setCellData(e.row, e.col, value?.Code);
              flex.setCellData(e.row, e.col + 1, value?.Name);
            } else flex.setCellData(3, 0, value?.Name);
          },
        });

      /* Construct filter */

      /* Call api */
    } else {
      e.cancel = false;
    }
  };

  const bv = (flex, e) => bringValueHandler({ flex, e });

  const gridInitialized = (flex) => {
    flex.rows.push(new Row());
    flex.rows.push(new Row());
    flex.rows.push(new Row());
    flex.rows.push(new Row());
    flex.rows.push(new Row());
    flex.columns.push(new Column({ header: "Column1", binding: "Column1" }));
    flex.columns.push(new Column({ header: "Column2", binding: "Column2" }));
    flex.cellEditEnding.addHandler(bv);
  };

  return (
    <div style={{ background: "red" }}>
      <FlexGrid style={{ width: "30%" }} initialized={gridInitialized} />
    </div>
  );
};

export default BringValueInGrid;
